import React from 'react';
import { components, InputProps } from 'react-select';
import { IDeceasedContact } from '~/types/IDeceasedContact';

export function Input(props: InputProps<IDeceasedContact, false>) {
  return <components.Input {...props} data-lpignore="true" />;
}
